var _excluded = ["children", "wfsStylesJson", "enableMetaTiles"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Fragment, useMemo, useState } from 'react';
import { getFeatureStyle, LayerSwitcher as ReactOlLayerSwitcher, TileLayer, VectorLayer, WMS, WMTS } from '../react-ol';
import { Geometry } from './Geometry';
import WMTSCapabilities from 'ol/format/WMTSCapabilities';
import { optionsFromCapabilities } from 'ol/source/WMTS';
import useApplication from '../hooks/useApplication';
import useDefaultsCache from '../hooks/useDefaultsCache';
import useGetCapabilities from '../hooks/useGetCapabilities';
import useTileLoader from '../hooks/useTileLoader';
import WFS from '../react-ol/components/WFS';
import { useDeepCompareMemoize } from 'use-deep-compare-effect';
import ClusterGeometry from './ClusterGeometry';
export var LayerSwitcher = _ref => {
  var {
    children,
    wfsStylesJson,
    enableMetaTiles
  } = _ref,
      layerSwitcherProps = _objectWithoutProperties(_ref, _excluded);

  var [serviceUrl, setServiceUrl] = useState(null);
  var {
    cachedDefaults
  } = useDefaultsCache();
  var {
    data: capabilities
  } = useGetCapabilities(serviceUrl, {
    enabled: !!serviceUrl
  });
  var [{
    stateRef
  }, {
    markSelectableLayersAsRendered
  }] = useApplication();
  var customLoader = useTileLoader();
  var memoizedEnableLayers = useDeepCompareMemoize(layerSwitcherProps.enableLayers);
  var wfsStyles = useMemo(() => getFeatureStyle(_objectSpread({
    zIndex: 4
  }, wfsStylesJson)), [wfsStylesJson]);
  var memoizedSortedLayers = useMemo(() => cachedDefaults === null || cachedDefaults === void 0 ? void 0 : cachedDefaults.layers.sort((a, b) => b.displayOrder - a.displayOrder), [cachedDefaults === null || cachedDefaults === void 0 ? void 0 : cachedDefaults.layers]);
  var memoizedCachedDefaultsOptions = useMemo(() => {
    if (cachedDefaults !== null && cachedDefaults !== void 0 && cachedDefaults.resolutions && cachedDefaults !== null && cachedDefaults !== void 0 && cachedDefaults.projection.matrixSetIdentifier) {
      var _cachedDefaults$copyr, _cachedDefaults$infor;

      return {
        resolutions: cachedDefaults.resolutions.length - 1,
        matrixSetIdentifier: cachedDefaults.projection.matrixSetIdentifier,
        attributions: "".concat((_cachedDefaults$copyr = cachedDefaults.copyrightCitation) !== null && _cachedDefaults$copyr !== void 0 ? _cachedDefaults$copyr : '', " ").concat((_cachedDefaults$infor = cachedDefaults.informationAttributes) !== null && _cachedDefaults$infor !== void 0 ? _cachedDefaults$infor : '')
      };
    }

    return undefined;
  }, [cachedDefaults === null || cachedDefaults === void 0 ? void 0 : cachedDefaults.resolutions, cachedDefaults === null || cachedDefaults === void 0 ? void 0 : cachedDefaults.projection.matrixSetIdentifier, cachedDefaults === null || cachedDefaults === void 0 ? void 0 : cachedDefaults.copyrightCitation, cachedDefaults === null || cachedDefaults === void 0 ? void 0 : cachedDefaults.informationAttributes]);
  var fetchedDefaultLayers = useMemo(() => {
    if (!memoizedSortedLayers || !memoizedCachedDefaultsOptions) return null;
    var {
      attributions,
      matrixSetIdentifier,
      resolutions
    } = memoizedCachedDefaultsOptions;
    return memoizedSortedLayers.map(layer => {
      var source;
      var layerProps = {
        id: layer.id,
        key: layer.id,
        label: layer.name,
        reference: layer.reference,
        canToggle: layer.canToggle,
        zIndex: layer.displayOrder,
        visible: layer.visibleByDefault,
        minZoom: layer.endVisibleScale.openLayersLevel === 0 ? undefined : layer.endVisibleScale.openLayersLevel,
        maxZoom: layer.startVisibleScale.openLayersLevel === resolutions ? undefined : layer.startVisibleScale.openLayersLevel
      };
      var serviceTypeName = layer.serviceType.name;

      switch (serviceTypeName) {
        case 'WMS':
          {
            source = /*#__PURE__*/React.createElement(WMS, {
              attributions: attributions,
              url: layer.serviceUrl,
              params: {
                LAYERS: layer.ogcLayerName
              },
              serverType: "geoserver",
              crossOrigin: "anonymous",
              customLoader: customLoader,
              enableMetaTiles: enableMetaTiles
            });
            break;
          }

        case 'WMTS':
          {
            setServiceUrl(layer.serviceUrl);
            if (!capabilities) break;
            var parser = new WMTSCapabilities();
            var result = parser.read(capabilities);
            var options = optionsFromCapabilities(result, {
              layer: layer.ogcLayerName,
              matrixSet: matrixSetIdentifier,
              format: 'image/png'
            });
            source = /*#__PURE__*/React.createElement(WMTS, _extends({
              attributions: attributions,
              customLoader: customLoader
            }, options));
            break;
          }

        case 'WFS':
          source = /*#__PURE__*/React.createElement(WFS, {
            layerDetails: {
              epsgName: layer.projection.epsgName,
              serviceUrl: layer.serviceUrl,
              ogcLayerName: layer.ogcLayerName
            }
          });
          break;

        default:
          console.error("Invalid layer service type: ".concat(layer.serviceType.name));
          return /*#__PURE__*/React.createElement(Fragment, null);
      }

      var isVectorLayer = serviceTypeName === 'WFS';
      return isVectorLayer ? /*#__PURE__*/React.createElement(VectorLayer, _extends({
        style: wfsStyles
      }, layerProps), source) : /*#__PURE__*/React.createElement(TileLayer, layerProps, source);
    });
  }, [capabilities, customLoader, enableMetaTiles, memoizedCachedDefaultsOptions, memoizedSortedLayers, wfsStyles]);
  var enhancedChildLayers = useMemo(() => {
    var selectableGeometryLayers = [];
    var restOfLayers = [];
    React.Children.forEach(children, child => {
      if (!child) return;
      return (child.type === Geometry || child.type === ClusterGeometry) && (child.props.canSelect || child.props.isSelectableLayer) ? selectableGeometryLayers.push(child) : restOfLayers.push(child);
    });
    var enhancedSelectableGeometryLayers = React.Children.map(selectableGeometryLayers, (child, i) => {
      // TODO - Add post render event to every selectable layer and only markSelectableLayersAsRendered when all are complete.
      // Or alternatively, find a way for consuming application to delay firing fitFeature until its target feature has rendered
      // The best solution would mark individual layers as 'ready', as opposed to the entire map being ready once all selectable layers have rendered
      var isLastChild = i === React.Children.count(selectableGeometryLayers) - 1;

      if (isLastChild) {
        return /*#__PURE__*/React.cloneElement(child, {
          onPostrender: () => {
            var _stateRef$current;

            if (!((_stateRef$current = stateRef.current) !== null && _stateRef$current !== void 0 && _stateRef$current.selectableLayersHaveRendered)) {
              markSelectableLayersAsRendered();
            }
          }
        });
      }

      return child;
    });
    return [...enhancedSelectableGeometryLayers, ...restOfLayers];
  }, [children, stateRef, markSelectableLayersAsRendered]);

  if (!fetchedDefaultLayers) {
    return /*#__PURE__*/React.createElement("div", null);
  }

  return /*#__PURE__*/React.createElement(ReactOlLayerSwitcher, _extends({}, layerSwitcherProps, {
    enableLayers: memoizedEnableLayers
  }), fetchedDefaultLayers, enhancedChildLayers);
};